<app-lcl-card cardTitle="LABELS.ADDITIONAL_SERVICES">
  <ng-container body>
    <div class="lcl-voyage-options">
      <h3>{{ "LABELS.CHECK_RELEVANT_SERVICES" | translate }}</h3>

      <ng-container *ngIf="isCompanyFromUSA && isDestinationUSA">
        <div class="lcl-option-row custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="option-isf"
            [value]="isOptionISFChecked"
            [checked]="formGroup.get('isfRequested').value"
            [disabled]="formGroup.get('isfRequested').disabled"
            (change)="onCheckedISF($event)"
          />

          <label class="custom-control-label" for="option-isf">
            <span>{{ "LCL_SHIPMENT.CUSTOM_OPTIONS.ISF" | translate }}</span>
            <p>{{ "LCL_SHIPMENT.CUSTOM_OPTIONS.ISF_HINT" | translate }}</p>
          </label>
        </div>

        <div class="lcl-option-row custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="option-es"
            [value]="isOptionESChecked"
            [checked]="formGroup.get('entrySummaryRequested').value"
            [disabled]="formGroup.get('entrySummaryRequested').disabled"
            (change)="onCheckedES($event)"
          />

          <label class="custom-control-label" for="option-es">
            <span>{{ "LABELS.CUSTOMS_CLEARANCE_ENTRY_SUMMARY" | translate }}</span>
            <p>{{ "LCL_SHIPMENT.CUSTOM_OPTIONS.ES_HINT" | translate }}</p>
          </label>
        </div>
      </ng-container>

      <div class="lcl-option-row custom-control custom-checkbox" *ngIf="formGroup.get('incoTermsType')?.value !== enumIncotermsType.FOB">
        <input
          type="checkbox"
          class="custom-control-input"
          id="option-el"
          [value]="isOptionExportLicenseChecked"
          [checked]="formGroup.get('exportLicenseRequested').value"
          [disabled]="formGroup.get('exportLicenseRequested').disabled"
          (change)="onCheckedExportLicense($event)"
        />

        <label class="custom-control-label" for="option-el">
          <span>{{ "LABELS.EXPORT_LICENSE" | translate }}</span>
          <p>{{ "LCL_SHIPMENT.CUSTOM_OPTIONS.EXPORT_LICENSE_HINT" | translate }}</p>
        </label>
      </div>

      <ng-container *ngIf="isDestinationUSA && isVoyageValidForInsurance">
        <div class="lcl-option-row with-data">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="option-marine-insurance"
              [formControl]="formGroup.get('marineInsuranceRequested')"
              (click)="onCheckedMarineInsurance($event)"
            />

            <label class="custom-control-label" for="option-marine-insurance">
              <span>{{ "MARINE_INSURANCE_ADD_FULL" | translate }}</span>
              <p>{{ "MARINE_INSURANCE_ADD_FULL_HINT" | translate }}</p>
            </label>
          </div>

          <div class="lcl-option-marine-insurance-view" *ngIf="!isInsuranceAvailable">
            <div class="lcl-option-marine-insurance-view-header">
              {{ "MARINE_INSURANCE_COST_DETAILS" | translate }}

              <button
                type="button"
                class="btn btn-link d-print-none"
                *ngIf="!isManagementView"
                (click)="optionMarineInsuranceUpdated.emit(true)"
              >
                <img src="assets/icons/icon_edit_dark_gray.svg" />

                <span class="ml-1">{{ "BUTTON.EDIT" | translate }}</span>
              </button>
            </div>

            <div class="lcl-option-marine-insurance-view-content">
              <app-marine-insurance-quote-view-data [marineInsurance]="currentInsurance"></app-marine-insurance-quote-view-data>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</app-lcl-card>

<custom-modal
  [header]="'MARINE_INSURANCE_DELETE_QUOTE_TITLE'"
  [open]="showDeleteQuoteModal"
  [isListenClose]="true"
  (closeClick)="discardDeleteQuote()"
>
  <p>{{ "MARINE_INSURANCE_DELETE_QUOTE_TEXT" | translate }}</p>

  <button footer-action type="button" class="btn btn-secondary" (click)="discardDeleteQuote()">{{ "BUTTON.CANCEL" | translate }}</button>

  <button footer-action type="button" class="btn btn-primary ml-2" (click)="confirmDeleteQuote()">
    {{ "BUTTON.CONFIRM" | translate }}
  </button>
</custom-modal>
